import React from 'react';
import {observer} from 'mobx-react';
import store from '../../../../s';
import Coord from '../../coord';
import {Portal} from '../../../../../util';
import {ICheckoutStep} from '../../../../i';

interface IMobileFooterProps {
    isMobile: boolean;
}

const MobileFooter = observer(({isMobile}: IMobileFooterProps) => {
    return (
        <>
            {isMobile && store.checkout.cart.items && store.checkout.cart.items.length > 0 && store.checkout.cstep === ICheckoutStep.cart && (
                <div
                    className="continue-shopping text-center"
                    style={{paddingBottom: 12}}
                >
                    <div className="hr" />
                    <a
                        href={store.getContinueShoppingLink()}
                        aria-label="Continue Shopping"
                    >
                        Continue Shopping {store.checkout.cart.items.length > 0 && store.checkout.cart.items[0].title1}
                    </a>
                </div>
            )}
            {isMobile && store.checkout.cart.items && store.checkout.cart.items.length > 0 && Portal && Portal.PortalID < 1 && store.checkout.cstep === ICheckoutStep.cart && <Coord />}
        </>
    );
});

export default MobileFooter;
